import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import {
  GetCampaignRewardTypesResponse,
  GetCampaignConditionTypesResponse,
  CreateCampaignInput,
  CreateCampaignResponse,
  GetCampaignListInput,
  GetCampaignListResponse,
  GetCampaignByIdResponse,
  UpdateCampaignInput,
  UpdateCampaignResponse,
} from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'

export const getCampaignRewardTypes = async (): Promise<GetCampaignRewardTypesResponse> => {
  const data: AxiosResponse<GetCampaignRewardTypesResponse> = await httpClient
    .get(API.getCampaignRewardTypes)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getCampaignConditionTypes = async (): Promise<GetCampaignConditionTypesResponse> => {
  const data: AxiosResponse<GetCampaignConditionTypesResponse> = await httpClient
    .get(API.getCampaignConditionTypes)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createCampaign = async (
  input: CreateCampaignInput
): Promise<CreateCampaignResponse> => {
  const data: AxiosResponse<CreateCampaignResponse> = await httpClient
    .post(API.createCampaign, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getCampaignList = async (
  input: GetCampaignListInput
): Promise<GetCampaignListResponse> => {
  const data: AxiosResponse<GetCampaignListResponse> = await httpClient
    .post(API.getCampaignList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getCampaignById = async (
  id: string
): Promise<GetCampaignByIdResponse> => {
  const data: AxiosResponse<GetCampaignByIdResponse> = await httpClient
    .get(`${API.getCampaignById}${id}`)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateCampaign = async (
  input: UpdateCampaignInput
): Promise<UpdateCampaignResponse> => {
  const data: AxiosResponse<UpdateCampaignResponse> = await httpClient
    .post(API.updateCampaign, input)
    .catch((error) => handleResponseError(error))
  return data.data
}
